import { getTextSentimentColor } from '@modules/feedback/utils';
import { Stack } from '@mui/material';
import { SentimentName } from 'generated/graphql';
import capitalize from 'lodash/capitalize';

interface SentimentOptionProps {
  sentiment: SentimentName;
}

export const SentimentOption = ({ sentiment }: SentimentOptionProps) => {
  return (
    <Stack direction="row" alignItems="center">
      <Stack
        borderRadius="50%"
        width="12px"
        height="12px"
        bgcolor={`${getTextSentimentColor(sentiment)}`}
        mr={1}
      />
      {capitalize(sentiment)}
    </Stack>
  );
};
